export default "__VITE_ASSET__U$5BtPz1__"